import { FC, useState } from 'react';

import styled from 'styled-components';

import { FlexibleDiv } from '@components/formStyles';

const Wrapper = styled.span`
  position: relative;
  margin: 15px 10px 0 0;
  transition: all 0.5s;
`;
const Description = styled.p<{ showFull: boolean }>`
  white-space: initial;
  max-height: ${({ showFull }) => (showFull ? '100vh' : '75px')};
  transition: all 0.7s;
`;

const ReadMore = styled.button`
  background-color: transparent;
  border: none;
  position: absolute;
  right: 20px;
  bottom: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.coral};
`;

interface ReadMoreDescriptionProps {
  description: string;
  initialVisibleLength: number;
}

const ReadMoreDescription: FC<ReadMoreDescriptionProps> = ({
  description,
  initialVisibleLength = 300,
}) => {
  const [showFullDescription, setShowFullDescription] = useState(false);

  const toggleDescription = () => setShowFullDescription((val) => !val);

  const shortDescription =
    description?.length > initialVisibleLength
      ? description?.slice(0, initialVisibleLength)
      : description;
  return (
    <Wrapper>
      <Description showFull={showFullDescription}>
        {showFullDescription ? description : shortDescription}
      </Description>{' '}
      {description?.length > initialVisibleLength ? (
        <ReadMore onClick={toggleDescription}>Devamını Oku</ReadMore>
      ) : null}
      <FlexibleDiv bottom={30} />
    </Wrapper>
  );
};

export default ReadMoreDescription;
